<template>


    <div class="">

      <div class="hidden-xs-only" style="height:50px;">

      </div>

      

      <!-- <v-layout row class=" primary pl-2 mb-3  hidden-sm-and-down " justify-center style="">
                          <v-flex  xs12 sm12 md10 offset-md1  class=" mr-3 ml-3 ">
                              <p class="mb-1 mdHeaderText mt-4 mb-4 " >  <span style="cursor:pointer"> Admin Panel </span>  &nbsp;&nbsp; > &nbsp;&nbsp; Messaging</p>
                          </v-flex>
                      </v-layout> -->
      <v-layout justify-center style="position:relative;" class="mt-3" >
        <v-flex xs12 md10>

            <v-layout elevation-3 style="background-color:white" >
              <!-- TASK LIST -->
              <v-flex xs12 md4 sm6 style="height:100%" >
                <!-- <div class="tasksHeader hidden-sm-and-down">
                <h5 class=" text-xs-center mb-2 mt-2 pa-1">Messaging</h5>                  
                </div>
                <v-layout row class=" primary pl-2 pr-2 hidden-md-and-up " style="">
                          <v-flex  xs12 sm12 offset-sm2  class=" mr-3 ml-3 white hidden-md-and-up">
                              <h3 class="mb-1 text-xs-center" style="color:grey">  Messaging</h3>
                          </v-flex>
                      </v-layout> -->




                <v-tabs fixed centered>
    <v-tabs-bar class="primary" dark style="height:6vh">
      <v-tabs-slider class="yellow"></v-tabs-slider>
      <v-tabs-item @click="preview=0"
        
        href='#tab-Read'
      >
        <p class="mb-0" style="color:white">{{gLang[lang].messaging.tabRead}}</p>
      </v-tabs-item>
      <v-tabs-item @click="preview=2"
        
        href='#tab-Write'
      >
       <p class="mb-0" style="color:white">{{gLang[lang].messaging.tabWrite}}</p>
      </v-tabs-item>
 
      
    </v-tabs-bar>
    <v-tabs-items>
      <v-tabs-content id="tab-Read" >
                <v-list>
                  <!-- <v-list-tile avatar   >
                      <v-list-tile-avatar>
                        <v-icon>inbox</v-icon>
                     </v-list-tile-avatar>
                    <v-list-tile-content >
                      <v-list-tile-sub-title>  {{gLang[lang].messaging.receiver}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile> -->


 <wb-new-message :users="users"></wb-new-message>

                  </v-list>
                  <v-layout row>
                   <v-flex xs12 sm12 >
                     <v-card style="box-shadow:none;">
                      <v-list three-line class="pt-0">
                       <template >
                         <div v-for="(conversation,i) in conversations" :key="i" >
                           <v-divider  ></v-divider> 
                           <v-list-tile avatar  @click="openConversation(conversation)">
                            <v-list-tile-avatar v-if="sender(conversation.userIds).picture">
                              <img v-if="sender(conversation.userIds).picture.url" :src="sender(conversation.userIds).picture.url+'_profile'" alt="avatar">
                              <img v-else :src="sender(conversation.userIds).picture" alt="avatar">
                            </v-list-tile-avatar>
                            <v-list-tile-avatar v-else >
                              <img src="../../assets/user-icon.png" alt="" class="avatarImg1">
                            </v-list-tile-avatar>
                            <v-list-tile-content  class="collection-list-ie mt-4" >
                              <v-list-tile-title v-html="sender(conversation.userIds).displayName"></v-list-tile-title>
                              <v-list-tile-sub-title> <b>{{conversation.subject}}</b> </v-list-tile-sub-title>
                              <v-list-tile-sub-title>{{strip(conversation.messages[conversation.messages.length-1].message).slice(0,30)}}...</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                         </div>
                      </template>
                     </v-list>
                   </v-card>
                  </v-flex>
                 </v-layout>
      </v-tabs-content>






      <v-tabs-content  id="tab-Write" >
               
                  <v-layout row>
                   <v-flex xs12 sm12 >
                     <v-card style="box-shadow:none;">
                      <v-list three-line class="pt-0">
                          <v-text-field append-icon="search" v-model="term" label="Input a user name" hide-details  class="searchBar "></v-text-field>
                          <v-layout row justify-center>
                           
                              <!-- <v-btn block class="ma-1">
                                {{gLang[lang].messaging.select}}
                              </v-btn>
                              <v-btn block class="ma-1" @click="preview = 3">
                                          {{gLang[lang].messaging.compose}}
                              </v-btn> -->
             
                          
                          
                          </v-layout>
                       <template >
                         <div v-for="(user,i) in methodResults" :key="i" >
                           <v-divider  ></v-divider> 
                           <v-list-tile avatar   >
                             <v-list-tile-avatar>
                              <v-checkbox v-model="user.selected" @change="addUser(user._id)"></v-checkbox>
                            </v-list-tile-avatar>
                            <v-list-tile-avatar v-if=" user.picture">
                              
                              <img v-if="user.picture.url" :src="user.picture.url+'_profile'" alt="avatar">
                              <img v-else :src="user.picture" alt="avatar">
                            </v-list-tile-avatar>

                            
                            <v-list-tile-avatar v-else >
                              
                              <img src="../../assets/user-icon.png" alt="" class="avatarImg1">
                            </v-list-tile-avatar>
                            <v-list-tile-content  class="collection-list-ie" >
                              <v-list-tile-title v-html="user.displayName"></v-list-tile-title>
                              <v-list-tile-sub-title> <b>{{user.email}}</b> </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                         </div>
                         <v-btn color="primary" class="mt-5 hidden-md-and-up" @click="NewMessageBool=true"> Send</v-btn>
                      </template>
                     </v-list>
                   </v-card>
                  </v-flex>
                 </v-layout>
      </v-tabs-content>
    </v-tabs-items>
  </v-tabs>

                

                <!-- <v-layout row>
    <v-flex xs12 sm12 >
      <v-card style="box-shadow:none;">
        <v-list three-line class="pt-0">
          <template >
            <div v-for="(artefact,i) in unreviewedArtefacts" :key="i" >
            <v-divider  ></v-divider> 
            <v-list-tile @click="previewOrRedirect(artefact._id)" avatar   >
              <v-list-tile-avatar>
                <img v-bind:src="artefact.mainImg[0].url"/>
              </v-list-tile-avatar>
              <v-list-tile-content v-for="(user,i) in users" :key="i" v-if="(user._id.indexOf(artefact.userId) > -1)">
                <v-list-tile-title v-html="artefact.title"></v-list-tile-title>
                <v-list-tile-sub-title v-html=" user.displayName + ' - ' +artefact.description"></v-list-tile-sub-title>
                
                          
              </v-list-tile-content>
                
            </v-list-tile>
            </div>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout> -->

 
              </v-flex>
             <v-dialog style="" class="hidden-md-and-up" fullscreen v-model="checkIfMobile">
              <!-- PREVIEW TASK -->
              <v-flex style="margin-top:98px;margin-bottom:70px " md8>
                <!-- <web-artefact-preview v-if="preview" :id="preview"> </web-artefact-preview> -->
                <v-container fluid v-if="preview==0" class="beginningContainer pa-5">
                  <h5><i> {{gLang[lang].messaging.preview}} frgefvdax</i></h5>
                </v-container>
                <v-container fluid v-if="selectedUsers.length==0 && preview == 2" class="beginningContainer pa-5">
                  <h5><i> {{gLang[lang].messaging.selectUsers}} </i></h5>
                </v-container>
                 <wb-conversation v-if="conversationBool && preview == 1" :subject="subject" :messages="messages" :conversationId="conversationId" @newMessage="updateConversation($event)" @closed="conversationBool = false"></wb-conversation>
           
                <v-container fluid v-if="selectedUsers.length>0 && preview == 2" class="beginningContainer pa-0 pl-3 pr-4">
                  
                  <div class="pt-5 pl-5" >
                    <p class="title">To:</p>
                  <span class="pt-5" v-for="user in selectedUsers" :key="user">{{email(user)}}  </span>
                  </div>
                  
                  <v-text-field  style="height:6vh;" class=""
              name="input-1-3"
              label="Subject"
              v-model="subject"
              single-line
              light
              required
              prepend-icon="chat"
            ></v-text-field>
            <v-flex xs12 sm12  class="text-xs-center mr-3 ml-3 mt-4">

                 <quill-editor class="editor-example snow"
                      ref="myTextEditor"
                      v-model="newMessage"
                      :options="editorOption"
                      >
                </quill-editor>

            </v-flex>

            <v-layout  class="pt-3" row>
             <v-spacer></v-spacer>
              <v-btn color="primary" class="mt-5" @click="sendMessage"> {{gLang[lang].messaging.send}} <v-icon right>send</v-icon></v-btn>
             <v-btn color="primary" class="mt-5 hidden-md-and-up"  @click="NewMessageBool=false"> close</v-btn>
            </v-layout>
                </v-container>
              </v-flex>
             </v-dialog>

                       
              <!-- PREVIEW TASK -->
              <v-flex md8 class="hidden-xs-only">
                <!-- <web-artefact-preview v-if="preview" :id="preview"> </web-artefact-preview> -->
                <v-container fluid v-if="preview==0" class="beginningContainer pa-5">
                  <h5><i> {{gLang[lang].messaging.preview}} </i></h5>
                </v-container>
                <v-container fluid v-if="selectedUsers.length==0 && preview == 2" class="beginningContainer pa-5">
                  <h5><i> {{gLang[lang].messaging.selectUsers}} </i></h5>
                </v-container>
                 <wb-conversation v-if="conversationBool && preview == 1" :subject="subject" :messages="messages" :conversationId="conversationId" @newMessage="updateConversation($event)" @closed="conversationBool = false"></wb-conversation>
           
                <v-container fluid v-if="selectedUsers.length>0 && preview == 2" class="beginningContainer pa-0 pl-3 pr-4">
                  
                  <div class="pt-5 pl-5" >
                    <p class="title">To:</p>
                  <span class="pt-5" v-for="user in selectedUsers" :key="user">{{email(user)}}  </span>
                  </div>
                  
                  <v-text-field  style="height:6vh;" class=""
              name="input-1-3"
              label="Subject"
              v-model="subject"
              single-line
              light
              required
              prepend-icon="chat"
            ></v-text-field>
            <v-flex xs12 sm12  class="text-xs-center mr-3 ml-3 mt-4">

                 <quill-editor class="editor-example snow"
                      ref="myTextEditor"
                      v-model="newMessageQuill"
                      :options="editorOption"
                      >
                </quill-editor>

            </v-flex>

            <v-layout  class="pt-3" row>
             <v-spacer></v-spacer>
              <v-btn color="primary" class="mt-5" @click="sendMessage"> {{gLang[lang].messaging.send}} <v-icon right>send</v-icon></v-btn>
              
            </v-layout>
                </v-container>
              </v-flex>
        
            
            </v-layout>

        </v-flex>
      </v-layout>
    </div>
</template>

<script>
import conversations from "@/components/Partials/ConversationTemplate.vue";
import newMessageDialog from "@/components/Partials/NewMessage.vue";
import { quillEditor } from "vue-quill-editor";
import axios from "axios";
export default {
  created() {
    if (!this.isLoggedIn) this.$router.push("/signin");
  },
  data() {
    return {
      NewMessageBool: false,
      reciever: "",
      subject: "",
      newMessageQuill: "",
      editorOption: {
        theme: "snow",
        placeholder: "Send a new Message",
        modules: {
          toolbar: [
            ["bold", "italic"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"]
          ]
        }
      },
      selectedUsers: [],
      newMessage: false,
      conversationBool: false,
      conversationId: "",
      subject: "",
      messages: [],
      conversations: "",
      preview: 0,
      term: "",
      defaultAllToggle: false,
      UserOptions: {
        keys: ["displayName", "email"]
      },
      notifications: "",
      methodResults: [],
      items: ["Read", "Write"],
      text: "",
      options: {
        toolbar: {
          buttons: [
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "h4",
            "h3",
            "h2",
            "justifyRight",
            "justifyLeft",
            "justifyCenter",
            "orderedlist",
            "unorderedlist"
          ]
        },
        anchor: {
          /* These are the default options for anchor form,
           if nothing is passed this is what it used */
          // customClassOption: 'alink',
          // customClassOptionText: 'Button',
          // linkValidation: false,
          // placeholderText: 'YOYOYO',
          // targetCheckbox: false,
          // targetCheckboxText: 'Open in new window'
        }
      }
    };
  },
  computed: {
    checkIfMobile() {
      var isMobile = window.matchMedia("only screen and (max-width: 760px)");

      if (
        isMobile.matches &&
        (this.conversationBool ||
          (this.selectedUsers.length > 0 && this.NewMessageBool))
      ) {
        return true;
      } else return false;
    },
    token() {
      return this.$store.getters.getToken;
    },
    editor() {
      return this.$refs.myTextEditor.quill;
    },
    lang() {
      return this.$store.getters.loadLang;
    },
    gLang() {
      return this.$store.getters.loadGlobLang;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    // artefacts() {
    //   return this.$store.getters.loadUnreviewdArtefacts;
    // },
    artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    collectionName() {
      return this.$store.getters.getCollectionName(this.id);
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod() {
      return this.$store.getters.isMod;
    },
    isContrib() {
      return this.$store.getters.isContrib;
    },
    users() {
      return this.$store.getters.loadUsers;
    },
    unreviewedArtefacts() {
      return this.$store.getters.loadUnreviewedArtefacts;
    },
    user() {
      return this.$store.getters.getUser;
    }
  },
  mounted() {
    axios.get("/api/messages/" + this.user._id).then(response => {
      this.conversations = response.data;
    });

    document.title = "Messaging";
    window.scrollTo(0, 0);
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadUsers");
  },
  methods: {
    sendMessage() {
      for (var selectedUser of this.selectedUsers)
        axios
          .post("/api/messages", {
            subject: this.subject,
            message: this.newMessageQuill,
            sender: this.user._id,
            reciever: selectedUser,
            token: this.token
          })
          .then(response => {
            this.updateConversations();
            this.newMessageQuill = "";
            this.subject = "";
          });
    },
    addUser(id) {
      if (this.selectedUsers.includes(id)) {
        var index = this.selectedUsers.indexOf(id); // <-- Not supported in <IE9
        this.selectedUsers.splice(index, 1);
      } else this.selectedUsers.push(id);
    },
    openNew() {
      this.newMessage = true;
    },
    strip(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    },
    updateConversation(conversationId) {
      axios.get("/api/messages/" + this.user._id).then(response => {
        this.conversations = response.data;
        this.messages = this.conversations.find(conv => {
          return conv._id == conversationId;
        }).messages;
      });
    },
    updateConversations(conversationId) {
      axios.get("/api/messages/" + this.user._id).then(response => {
        this.conversations = response.data;
      });
    },
    openConversation(conversation) {
      this.preview = 1;
      this.conversationId = conversation._id;
      this.conversationBool = true;
      this.messages = conversation.messages;
      this.subject = conversation.subject;
    },
    email(userId) {
      return this.$store.getters.loadSingleUser(userId).email;
    },
    sender(userIds) {
      if (this.user._id == userIds[0])
        return this.$store.getters.loadSingleUser(userIds[1]);
      else return this.$store.getters.loadSingleUser(userIds[0]);
    },
    previewOrRedirect(id) {
      if (screen.width > 960) {
        this.preview = id;
      } else {
        this.$router.push("/artefacts/" + id);
      }
    },
    applyTextEdit(index, ev) {
      console.log(ev);

      if (ev.event.target) {
        console.log(ev.event.target.innerHTML);
        this.formUpload.uploads[index].value = ev.event.target.innerHTML;
      }
    },
    provider(user) {
      if (user.hasOwnProperty("facebook")) return "Facebook";
      else if (user.hasOwnProperty("google")) return "Google";
      else if (user.hasOwnProperty("live")) return "Microsoft Live";
      else return "Local Register";
    }
  },
  watch: {
    term() {
      this.$search(this.term, this.users, this.UserOptions).then(results => {
        this.methodResults = results;
        if (this.term == "") {
          this.methodResults = this.users;
        }
      });
    }
  },
  components: {
    quillEditor,
    "wb-conversation": conversations,
    "wb-new-message": newMessageDialog
  }
};
</script>

<style src="@/../node_modules/medium-editor/dist/css/medium-editor.css">

</style>

<style src="@/../node_modules/medium-editor/dist/css/themes/default.css">

</style>


<style scoped>
.collection-list-ie {
  display: inline;
}

.mediumEditor {
  outline: none;
  min-height: 60px;
  text-align: left;
  border-bottom: 2px solid #efefef;
}

.headline {
  position: absolute;
  bottom: 3%;
  left: 3%;
}

.tasksHeader {
  background-color: white;
  color: grey;
  border: 1px solid #efefef;
}

.beginningContainer {
  background-color: white;
  height: 100%;
  border-left: 1px solid #efefef;
  color: grey;
}
.mdHeaderText {
  font-size: 1.1em;

  color: white;
}

.avatar2 {
  width: 44px;
  height: 44px;

  border: 12px solid white;
}
.searchBar {
  /* padding-top:0px; */

  text-indent: 20px;
  padding-bottom: 15px;
  padding-left: 20px;
  padding-right: 20px;
}
</style>
  
  <style>
.ql-container {
  font-family: "Roboto", sans-serif !important;
}
</style>


<style lang="scss" scoped>
.quill-editor,
.quill-code {
  height: 20rem;

  font-family: "Roboto", sans-serif;
}
.quill-editor {
  border-bottom: none;
  padding: 1rem;
  font-family: "Roboto", sans-serif;
}
.quill-code {
  border: none;
  height: auto;
  > code {
    font-family: "Roboto", sans-serif;
    width: 70%;
    margin: 10px;
    padding: 1rem;
    border: 1px solid #ccc;
    border-radius: 0;
    height: 10rem;
    overflow-y: auto;
  }
}
</style>

<style src='@/../static/quill.snow.css'>


// WEBPACK FOOTER //
// src/components/Administration/Messaging.vue